import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface Row {
  old_software: string | null;
  new_software: string;
  noted_at: string;
}

interface Props {
  forumUuid: string;
  darkMode: boolean;
}

const SoftwareMigrationHistory: React.FC<Props> = ({ forumUuid, darkMode }) => {
  const [rows, setRows] = useState<Row[]>([]);

  useEffect(() => {
    supabase
      .from('forum_software_migrations')
      .select('old_software, new_software, noted_at')
      .eq('forum_id', forumUuid)
      .order('noted_at', { ascending: false })
      .then(({ data }) => setRows(data || []));
  }, [forumUuid]);

  if (!rows.length) return null;

  return (
    <div className="mt-6">
      <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Yazılım geçmişi</h3>
      <ul className={`text-sm space-y-1 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        {rows.map((r, i) => (
          <li key={i}>
            {r.old_software || '?'} → {r.new_software} ({new Date(r.noted_at).toLocaleDateString('tr-TR')})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SoftwareMigrationHistory;
